(ns practitest.frontend.components.preview
  (:require [reagent.core :as reagent]
            [practitest.frontend.components.modal :as modal]
            [practitest.frontend.common.dom :as dom]
            [clojure.string :as str]
            [goog.Uri :as uri]
            [practitest.frontend.common.uri :refer [has-query-param? set-query-param]]))

(defn- pattachment-path?
  [path]
  ;; TODO: pass in configuration / use client-side router ?
  (re-matches #"/projects/\d+/pattachments/\d+" path))

(defn- external?
  [url]
  (try
    (let [parsed (uri/parse url)
          absolute? (.hasDomain ^goog.Uri parsed)
          path (.getPath ^goog.Uri parsed)]
      (and absolute?
           (not (pattachment-path? path))))
    (catch js/Error _
      true)))

(defn attachment-with-preview
  [_]
  (let [preview-state (reagent/atom {:show? false})
        container-ref (atom nil)]
    (fn [url]
      (let [external? (external? url)

            image-url (if external?
                        ;; External URLs should be treated as is
                        url

                        ;; Internal URLs can have style query param attached
                        (if (has-query-param? url "style" "thumb")
                          (set-query-param url "style" "original")
                          url))

            preview-url (if external?
                          url

                          ;; For internal URLs we should use "style" query param
                          (if (has-query-param? url "style" "thumb")
                            url
                            (set-query-param url "style" "thumb")))]
        [:<>
         [modal/bootstrap-modal
          {:is-open?         (:show? @preview-state)
           :on-request-close (fn []
                               (swap! preview-state assoc :show? false))
           :container-ref    container-ref
           :class            "image-preview-modal"
           :scrollable?      true
           :centered?        true}
          nil
          [:img.clickable.img-fluid
           {:alt      "Attachment"
            :src      image-url
            :on-click (fn [e]
                        (dom/stop-propagation e)
                        (swap! preview-state assoc :show? false))}]]

         [:img.clickable.img-thumbnail
          {:alt       "Attachment"
           :ref       (dom/root-ref-handler container-ref)
           :draggable false
           :src       preview-url
           :on-error (fn [e]
                       ;; if thumbnail fails to load (for instance for imported projects), fall back to original
                       (let [target (.-target e)
                             current-src (.-src target)]
                         (when (has-query-param? current-src "style" "thumb")
                           (set! (.-src target) (set-query-param url "style" "original")))))
           :on-click (fn [e]
                       (dom/stop-propagation e)
                       (swap! preview-state assoc :show? true))}]]))))
